import type { PropertyDetail } from '@/types'
import { createContext } from 'react'

export type PropertyDetailsContextProps = {
  property: PropertyDetail | undefined
  setProperty: (property: PropertyDetail | undefined) => void
};

export const PropertyDetailsContext = createContext<PropertyDetailsContextProps | null>(null);
